import ShareDiscoveryModal from "./ShareDiscoveryModal";

export default ShareDiscoveryModal;
